<template>
  <el-dialog v-model="currentAttachment" width="80%">
    <div class="flex justify-center">
      <img v-if="isImage(currentAttachment?.filename)" class="el-upload-list__item-thumbnail"
           :src="settingsStore.storagePath + '/vendor-bills/' +
                     vendorBill.id + '/' + currentAttachment.filename"
           alt="" width="80%">
      <embed v-if="isPDF(currentAttachment?.filename)" :src="settingsStore.storagePath + '/vendor-bills/' +
                     vendorBill.id + '/' + currentAttachment.filename" width="100%" height="600px"/>
    </div>
  </el-dialog>
  <div class="flex flex-col gap-4">
    <div v-if="vendorBill?.id" class="flex flex-col gap-4">
      <div>
        <div class="gap-2">

          <ul class="flex flex-wrap el-upload-list el-upload-list--picture-card">
            <li :key="i"
                v-for="(vendorBillAttachment, i) in vendorBill.vendorBillAttachments"
                class="el-upload-list__item">
              <div class="w-[148px]">
                <template
                    v-if="vendorBillAttachment.mimetype == 'image/png' || vendorBillAttachment.mimetype == 'image/jpeg'">
                  <img class="el-upload-list__item-thumbnail"
                       :src="settingsStore.storagePath + '/vendor-bills/' +
                     vendorBill.id + '/' + vendorBillAttachment.filename"
                       alt="">
                </template>
                <template v-else>
                  <div class="w-full h-full flex items-center justify-center">
                    <el-icon @click="() => {}" style="font-size: 48px">
                      <Document/>
                    </el-icon>
                  </div>
                </template>

                <label
                    class="absolute left-[50%] translate-x-[-50%] bottom-0 bg-black/45 text-white p-1 w-[100%] truncate">
                  {{ vendorBillAttachment.originalFilename }}
                </label>
                <span class="el-upload-list__item-actions">
                   <span v-if="canBePreviewed(vendorBillAttachment.filename)" class="el-upload-list__item-preview">
                 <el-icon @click="() =>
                  {currentAttachment = vendorBillAttachment}">
                  <Icon icon="icon-park-outline:preview-open"/>
                </el-icon>
               </span>
              <span class="el-upload-list__item-preview">
                 <el-icon @click="() =>
                  {downloadAttachment(vendorBillAttachment)}">
                  <Download/>
                </el-icon>
               </span>
              <span class="el-upload-list__item-delete">
                 <el-icon
                     @click="() => {handleRemoveOnRemote(vendorBillAttachment)}">
                  <Delete/>
                </el-icon>
              </span>
            </span>
              </div>
            </li>
            <li>
              <el-upload
                  class="w-[146px] h-[147px]"
                  drag
                  multiple
                  :show-file-list="false"
                  :action="`${VendorBill.ENDPOINT}/${vendorBill?.id}/attachments`"
                  :on-success="onSuccess"
                  :on-error="showError"
                  :http-request="handleUpload"
              >
                <div class="m-[17px] text-xl">
                  <el-icon>
                    <Plus/>
                  </el-icon>
                </div>
              </el-upload>
            </li>
          </ul>

        </div>

      </div>
    </div>

  </div>
</template>
<script setup lang="ts">
import {useHTTP} from "@/plugins/http";
import {defineEmits, onMounted, ref} from "vue";
import {Delete, Document, Download, Plus} from '@element-plus/icons-vue'
import type {UploadFile, UploadFiles, UploadRequestOptions} from 'element-plus'
import {ElMessage} from 'element-plus'
import {useI18n} from "vue-i18n";
import {useSettingsStore} from "@/stores/settingsStore";
import VendorBill, { VendorBillAttachment } from "@/models/vendor/VendorBill";
import {Icon} from "@iconify/vue";
import {canBePreviewed, isImage, isPDF} from "@/lib/utils";

const props = defineProps(['modelValue', 'data'])
const emit = defineEmits(['update:modelValue'])

const {t} = useI18n({
  messages: {
    en: {
      uploadAttachment: 'Upload Attachments',
    },
    ar: {
      uploadAttachment: 'رفع مرفقات',
    }
  }
})


const http = useHTTP()
const settingsStore = useSettingsStore();
const vendorBill = ref<VendorBill>();
const currentAttachment = ref<VendorBillAttachment>();

onMounted(() => {
  vendorBill.value = props.data as VendorBill
})

async function downloadAttachment(vendorBillAttachment: VendorBillAttachment) {
  try {
    const response = await fetch(settingsStore.storagePath + '/vendor-bills/' +
        vendorBill.value?.id + '/' + vendorBillAttachment.filename);
    if (!response.ok) throw new Error('Network response was not ok');
    const blob = await response.blob();
    const urlObject = window.URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = urlObject;
    link.download = vendorBillAttachment.originalFilename || 'downloaded-file';

    // Append link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger download
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(urlObject);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

function handleRemoveOnRemote(uploadFile: any) {
  http.delete(`${VendorBill.ENDPOINT}/attachments/${uploadFile.id}`).then(resp => {
    onSuccess()
  })
}


function handleUpload(options: UploadRequestOptions) {
  const data = new FormData();
  data.set('attachment', options.file)
  return http.put(options.action, data)
}

function showError(error: any, uploadFile: UploadFile, uploadFiles: UploadFiles) {
  ElMessage({
    showClose: true,
    message: error?.title,
    type: 'error',
  })
}

async function onSuccess() {
  vendorBill.value = await http.get<VendorBill>(VendorBill.ENDPOINT +
      `/${vendorBill.value?.id}`);
}

</script>
<style scoped>

</style>
